import {
  CompetitorWrapper,
  CompetitorDetails,
  CompetitorContent,
  SnowflakeSkeleton,
} from './styled';

const CompetitorSkeleton = () => {
  return (
    <CompetitorWrapper data-cy-id="competitor-skeleton" disabled>
      <CompetitorContent>
        <SnowflakeSkeleton>
          <div />
        </SnowflakeSkeleton>
        <CompetitorDetails empty>
          <p>&nbsp;</p>
          <h4>&nbsp;</h4>
          <h5>&nbsp;</h5>
        </CompetitorDetails>
      </CompetitorContent>
    </CompetitorWrapper>
  );
};
export default CompetitorSkeleton;
